import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  POST_CPSP_REQUEST: '',
  POST_CPSP_SUCCESS: '',
  POST_CPSP_FAILURE: '',
};

types = setStoreTypeValues(types, 'authCPSP');

export default types;
